import { UI, HStack, VStack } from '@genial/components';
import { BoxRadius, Typography } from '@genial/design-tokens';
import { Box, Button, Pressable } from 'native-base';
import React, { useState } from 'react';

import { useDownloadFileWithScreenLock } from '../../../../../../../../../../../hooks/useDownloadFileWithScreenLock';
import { PrivatePensionDetailsNormalized } from '../../../../../../../../../../../store/product/types';
import { ItemDetailsComponentProps } from '../../types';

export const PrivatePensionDetailsDocuments: React.FC<ItemDetailsComponentProps> = ({
  details,
  loading,
}) => {
  const { downloadFile } = useDownloadFileWithScreenLock();
  const [documentsOpen, setDocumentsOpen] = useState(true);

  const handleChangeDocumentsOpen = () => {
    setDocumentsOpen((state) => !state);
  };

  const handleOpenLink = (url: string) => {
    window.open(url, '_blank');
  };

  const handleOpenDocument = (document: PrivatePensionDetailsNormalized['documents'][number]) => {
    if (document.fileImage) {
      return downloadFile(document.fileImage, { fileName: `${document.fileName}.pdf` });
    }
    handleOpenLink(document.fileUrl);
  };

  return (
    <Box bg="background" px="inline.xxxs" mt="stack.xxxs" borderRadius={BoxRadius.sm}>
      <Pressable w="full" py="stack.xxxs" onPress={handleChangeDocumentsOpen}>
        <HStack justifyContent="space-between" alignItems="center">
          <UI.Text variant="semibold" isLoading={loading} maxW="1/3">
            Documentos
          </UI.Text>
          {!loading && <UI.Icon name={documentsOpen ? 'ChevronUp' : 'ChevronDown'} size="xs" />}
        </HStack>
      </Pressable>
      {!!documentsOpen && (
        <VStack space="stack.xxxs" pb="stack.xxxs">
          {details?.documents.map((document, id) => (
            <Button
              key={`document-${id}`}
              onPress={() => handleOpenDocument(document)}
              variant="textLink"
              p={0}
              isDisabled={!document.fileAvailable}
              _text={{
                textTransform: 'none',
                fontFamily: Typography['fontfamily.base.semibold'],
                fontSize: Typography['fontsize.xs'],
              }}
              justifyContent="start"
              leftIcon={<UI.Icon name="Download" size="xxxs" color="brand.tertiary.principal" />}>
              {document.fileName}
            </Button>
          ))}
        </VStack>
      )}
    </Box>
  );
};
